export function hasUpdates(initialData: any, previousData: any): boolean {
  return Object.entries(previousData).some(([category, values]) => {
    if (typeof values === 'object' && values !== null) {
      return Object.entries(values).some(([questionTemplateId, value]) => {
        const initialValue = initialData?.[category]?.[questionTemplateId];

        // Convert to comparable format
        const transformedValue = Array.isArray(value)
          ? value.join(', ')
          : typeof value === 'object'
          ? JSON.stringify(value)
          : String(value);

        const initialTransformedValue =
          initialValue !== undefined
            ? Array.isArray(initialValue)
              ? initialValue.join(', ')
              : typeof initialValue === 'object'
              ? JSON.stringify(initialValue)
              : String(initialValue)
            : null;

        return transformedValue !== initialTransformedValue;
      });
    }
    return false;
  });
}
